import { gql } from "@apollo/client";
import { AutomationUseCase } from "./AddAutomation/AddAutomation";

export const GET_AUTOMATION_USE_CASES = gql`
  query getAutomationUseCases {
    automation_use_cases {
      valid
      id
      title
      icon
      description
      endpoint_type
      labels
      selection_rule {
        filtersid
      }
      integrations {
        friendly_name
        type
      }
      automation_type
    }
  }
`;

type TestAutomationUseCase = Omit<AutomationUseCase, "automation_type"> & {
  automation_type: string;
};

export const generateGetAutomationUseCasesMock = ({
  result,
}: {
  result: {
    automation_use_cases: TestAutomationUseCase[];
  };
}) => ({
  request: {
    query: GET_AUTOMATION_USE_CASES,
  },
  result: {
    data: result,
  },
});

export const CREATE_AUTOMATION = gql`
  mutation createAutomation(
    $name: String!
    $trigger: TriggerInput!
    $filters_config: FiltersConfigInput!
    $action: ActionInput!
  ) {
    create_automation(
      name: $name
      trigger: $trigger
      filters_config: $filters_config
      action: $action
    ) {
      automation {
        id
      }
    }
  }
`;

export const EDIT_AUTOMATION = gql`
  mutation editAutomation(
    $id: String!
    $name: String!
    $trigger: TriggerInput!
    $filters_config: FiltersConfigInput!
    $action: ActionInput!
  ) {
    edit_automation(
      id: $id
      name: $name
      trigger: $trigger
      filters_config: $filters_config
      action: $action
    ) {
      automation {
        id
      }
    }
  }
`;

export const GET_AUTOMATION = gql`
  query getAutomation($id: String!) {
    get_automation(id: $id) {
      id
      name
      trigger {
        type
        value
      }
      selection_rule {
        filtersid
        scopesid
        scope_group
      }
      action {
        type
        params
      }
    }
  }
`;
